var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { getStatusTranslation } from "../../utils/getStatusTranslation";
import { FieldRow } from "../../components/FieldRow";
import { AccordionSection } from "../../components/AccordionSection";
import { ListSection } from "../../components/ListSection";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
import { AuthoritySendErrorBanner } from "../../components/AuthoritySendErrorBanner";
import { LocalAuthorityBanner } from "../../components/LocalAuthorityBanner";
import { PersonTitlesSection } from "../../components/PersonTitlesSection";
var NaturalPersonDetail = function (_a) {
    var _b, _c, _d, _e;
    var naturalPerson = _a.naturalPerson;
    var intl = useIntl();
    var _f = useState({
        general: true,
        identifiers: true,
        alternativeNames: true,
        titles: true,
    }), accordionStatus = _f[0], setAccordionStatus = _f[1];
    var _g = useState(true), expandAll = _g[0], setExpandAll = _g[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
                identifiers: false,
                alternativeNames: false,
                titles: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
                identifiers: true,
                alternativeNames: true,
                titles: true,
            });
        }
        setExpandAll(!expandAll);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.detail.pane.title" })),
        React.createElement(LocalAuthorityBanner, { person: naturalPerson }),
        React.createElement(AuthoritySendErrorBanner, { person: naturalPerson }),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-agency.natural-person.accordions.label.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.sourceId.field.label", value: naturalPerson.sourceId }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.firstName.field.label", value: naturalPerson.firstName })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.lastName.field.label", value: naturalPerson.lastName }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.birthDate.field.label", value: (_b = naturalPerson.birthDate) !== null && _b !== void 0 ? _b : undefined })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.deathDate.field.label", value: (_c = naturalPerson.deathDate) !== null && _c !== void 0 ? _c : undefined }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.biographicalNote.field.label", value: naturalPerson.biographicalNote })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.status.field.label", value: getStatusTranslation(intl, naturalPerson.status) })))),
            React.createElement(ListSection, { id: "identifiers-info", labelId: "ui-br-agency.natural-person.accordions.label.identifiers", items: (_d = naturalPerson.identifiers) !== null && _d !== void 0 ? _d : [], noItemsMessageId: "ui-br-agency.natural-person.identifier.no-identifiers", open: accordionStatus.identifiers, onToggle: function () { return toggleAccordion("identifiers"); }, renderItem: function (identifier, idx) { return (React.createElement(Row, { key: identifier.id || idx, style: { marginBottom: 15 } },
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.identifier.type.field.label", value: identifier.type })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.identifier.value.field.label", value: identifier.identifier })))); } }),
            React.createElement(ListSection, { id: "alternative-names-info", labelId: "ui-br-agency.natural-person.accordions.label.alternativeNames", items: (_e = naturalPerson.naturalAlternativeNames) !== null && _e !== void 0 ? _e : [], noItemsMessageId: "ui-br-agency.natural-person.alternativeName.no-alternative-names", open: accordionStatus.alternativeNames, onToggle: function () { return toggleAccordion("alternativeNames"); }, renderItem: function (altName, index) { return (React.createElement(Row, { key: altName.id || index, style: { marginBottom: "15px" } },
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.alternativeName.firstName.field.label", value: altName.firstName })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.natural-person.alternativeName.lastName.field.label", value: altName.lastName })))); } }),
            React.createElement(PersonTitlesSection, { kind: "natural", personId: naturalPerson.id, open: accordionStatus.titles, onToggle: function () { return toggleAccordion("titles"); } }))));
};
export default NaturalPersonDetail;
